function initialize() {
    $('.page-recipes select[name="category"]').on('change', function (evt) {
        if ($(this).val()) {
            window.location = '/receitas/' + $(this).val();
        }
    });
}

initialize();
